import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "viewsets-body" }
const _hoisted_2 = { class: "resolution-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "resolution-icon-box" }
const _hoisted_5 = { class: "resolution-text" }

import { computed, getCurrentInstance, onBeforeMount, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { $enum } from '@/global'
import { getUserResolutionSetting, saveUserResolutionSetting } from '@/service'

type ResolutionType = 'qhd' | 'fhd' | 'hd'
type ResolutionValue = '2560x1440' | '1920x1080' | '1280x720'

const messageDuration = 1200

const defaultResolution: ResolutionType = 'fhd'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()
const loading = ref(false)
const saveLoading = ref(false)
const currentResolution = ref<ResolutionType>(null)

const resolutionList = [
    { label: '2560*1440（超清）', value: 'qhd' as ResolutionType, subLebel:'1440' },
    { label: '1920*1080（高清）', value: 'fhd' as ResolutionType, subLebel:'1080' },
    { label: '1280*720（标清）', value: 'hd' as ResolutionType, subLebel:'720' },
]

const resolutionLabel = computed(() => {
    const current = resolutionList.find(item => item.value === currentResolution.value)
    return current?.label || ''
})

const resolutionToApiValueMap: Record<ResolutionType, ResolutionValue> = {
    qhd: '2560x1440',
    fhd: '1920x1080',
    hd: '1280x720',
}

const apiValueToResolutionMap: Record<string, ResolutionType> = {
    '2560x1440': 'qhd',
    '1920x1080': 'fhd',
    '1280x720': 'hd',
}

function playClick() {
    const clickHandler = (window as any)?.playClick
    if (typeof clickHandler === 'function') {
        clickHandler()
    }
}

function resolveResolutionType(resolution:string | null | undefined){
    if(!resolution){
        return defaultResolution;
    }
    return apiValueToResolutionMap[resolution] || defaultResolution;
}

async function getData(userId:number){
    loading.value = userId === -1;
    let {code, data} = await getUserResolutionSetting({userId}) as any;
    loading.value = false;
    if(code != $enum.EnumResult.SUCCESS){
        if(userId === -1){
            proxy?.vknMessage.error({
                message: '恢复默认失败！',
                duration: messageDuration,
            })
        }
        return;
    }
    const resolutionValue = (typeof data === 'string' ? data : null) as ResolutionValue | null;
    currentResolution.value = resolveResolutionType(resolutionValue);
    if(resolutionValue){
        store.commit('persistence/setResolution', resolutionValue);
    }
    if(userId === -1){
        proxy?.vknMessage.success({
            message: '恢复默认成功！',
            duration: messageDuration,
        })
    }
}

function handleSelect(value: ResolutionType) {
    currentResolution.value = value
    playClick()
}

async function handleRestore() {
    playClick()
    await getData(-1)
}

async function handleSave() {
    playClick()
    const params = {
        userId: store.state.persistence.userInfo.userId,
        resolution: resolutionToApiValueMap[currentResolution.value],
    }
    saveLoading.value = true;
    let {code, data} = await saveUserResolutionSetting(params) as any;
    saveLoading.value = false;
    if(code != $enum.EnumResult.SUCCESS || !data){
        proxy?.vknMessage.error({
            message: '保存失败！',
            duration: messageDuration,
        })
        return;
    }
    store.commit('persistence/setResolution', params.resolution);
    proxy?.vknMessage.success({
        message: `保存成功`,
        duration: messageDuration,
    })
}
onBeforeMount(() => {
    const userId = store.state.persistence.userInfo.userId;
    if(userId !== null && userId !== undefined){
        getData(userId);
    }
})

return (_ctx: any,_cache: any) => {
  const _component_vkm_settingChildPage = _resolveComponent("vkm-settingChildPage")!

  return (_openBlock(), _createBlock(_component_vkm_settingChildPage, {
    class: "viewsets-container",
    "restore-loading": loading.value,
    "save-loading": saveLoading.value,
    onRestore: handleRestore,
    onSave: handleSave
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(resolutionList, (item) => {
            return _createElementVNode("div", {
              key: item.value,
              class: _normalizeClass(["resolution-card", { active: currentResolution.value === item.value }]),
              onClick: ($event: any) => (handleSelect(item.value))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", null, _toDisplayString(item.subLebel), 1)
              ]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.label), 1)
            ], 10, _hoisted_3)
          }), 64))
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "resolution-tip" }, "分辨率说明：无独显【标清】，显存≤6G【高清】，显存>6G【超清】。", -1))
      ])
    ]),
    _: 1
  }, 8, ["restore-loading", "save-loading"]))
}
}

})